interface IUserWithAddtionalColumn {
  login: string;
  tag: string;
}

export const usersWithAdditionalColumn: IUserWithAddtionalColumn[] = [
  {login: "Lital", tag: "סל התרופות"},
  // {login: "ChaniG3", tag: "סל התרופות"},
  {login: "LiorT1", tag: "סל התרופות"},
  {login: "SariK4", tag: "סל התרופות"},
  {login: "GiladAdmin", tag: "סל התרופות"},
  {login: "DAN", tag: "סל התרופות"},
  {login: "Rotem Ben Yosef", tag: "סל התרופות"},
];
